/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import './style/statusBanner.scss';

import React from 'react';

import {
    BluemateAutoEmailStatus,
    BluemateAutoUploadStatus,
    BluemateBolConnectionStatus,
    BluemateEmailSetupCard,
    BluemateInvoiceDesignCard,
    BluemateInvoiceUploadCard,
    BluemateVatSetupCard
} from '../../controls';

import {StatusTileState} from '../../controls/statusTile/bluemateStatusTile';

/** What every tile in this banner needs, whichever status it reports: the light
 *  it shows and, when there is something to fix, where that leads. One prop per
 *  tile instead of a pair that grows with each one. */
export interface StatusTileControl {
    state: StatusTileState;
    onClick?: () => void;
}

/** What every setup card needs: whether its step is behind it, where the card
 *  leads, and the corner check that is what actually completes it. Same
 *  one-prop-per-element shape as the tiles above. */
export interface SetupCardControl {
    completed: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
}

interface Props {
    bolConnection: StatusTileControl;
    autoEmail: StatusTileControl;
    autoUpload: StatusTileControl;
    /** The whole setup row drops out once it has nothing left to ask for. */
    showSetupCards: boolean;
    invoiceDesign: SetupCardControl;
    vatProducts: SetupCardControl;
    emailSetup: SetupCardControl;
    invoiceUpload: SetupCardControl;
}

export default function StatusBanner(props: Props) {
    const {
        bolConnection,
        autoEmail,
        autoUpload,
        showSetupCards,
        invoiceDesign,
        vatProducts,
        emailSetup,
        invoiceUpload
    } = props;

    function renderSetupCards() {
        if (!showSetupCards) return null;
        return (
            <div className='status-banner-cards'>
                <BluemateInvoiceDesignCard {...invoiceDesign} />
                <BluemateVatSetupCard {...vatProducts} />
                <BluemateEmailSetupCard {...emailSetup} />
                <BluemateInvoiceUploadCard {...invoiceUpload} />
            </div>
        );
    }

    return (
        <div className='status-banner'>
            <div className='status-banner-tiles'>
                <BluemateBolConnectionStatus {...bolConnection} />
                <BluemateAutoEmailStatus {...autoEmail} />
                <BluemateAutoUploadStatus {...autoUpload} />
            </div>
            {renderSetupCards()}
        </div>
    );
}
